module.exports = __webpack_public_path__ + "info-icon-red.63fdab8dc5374231469fb958ab54892d.svg";